import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Navbar from './Navbar';
import Footer from './Footer';
import Certifications from './Certification';
import './service.css';
import badge from '../assets/images/intuit-bookkeeping-certification.png';
import TopBar from './TopBar';

const service = [
  {
    icon: '../assets/images/tax.jpeg',
    title: 'Tax Consultancy',
    subtitle: '🛡️ CERTIFIED TAX ADVISORY',
    description:
      'We help prepare and file VAT, PAYE, Income Tax, Withholding, and local government taxes.',
    highlight: false,
  },
  {
    icon: '../assets/images/desf.jfif',
    title: 'Business Development',
    description:
      'We create business and strategic plans, company profiles, and winning grant proposals.',
    highlight: false,
  },
  {
    icon: '../assets/images/desb.jfif',
    title: 'Bookkeeping & Accounting',
    description:
      'Bookkeeping, reconciliation, reporting, annual return filing, and financial advisory.',
    highlight: false,
  },
  {
    icon: '../assets/images/desh.jfif',
    title: 'HR & Management Consultancy',
    description:
      'We provide HR manuals, NGO statutes, internal regulations, and recruitment support.',
    highlight: false,
  },
  {
    icon: '../assets/images/desp.jfif',
    title: 'Professional Training',
    description:
      '“Wise Accountants” program covering QuickBooks, Excel, Taxation, and financial literacy.',
    highlight: false,
    link: 'https://docs.google.com/forms/d/e/1FAIpQLSfOJu8ZO5lPNXmaASFaKiyPWUkHW-PHgZCsQ8bEA7SRlphIWA/viewform?usp=dialog',
  },
  {
    icon: '../assets/images/desi.jfif',
    title: 'Software Installation',
    description: 'Installation and training on accounting software tailored to your business.',
    highlight: false,
  },
];

const faqs = [
  {
    id: 'One',
    question: 'How can I get a refund?',
    answer:
      'Lorem Ipsum is placeholder text used in design, typesetting, and printing since the 1500s.',
  },
  {
    id: 'Two',
    question: 'Which license should I need?',
    answer:
      'Lorem Ipsum is placeholder text used in design, typesetting, and printing since the 1500s.',
  },
  {
    id: 'Three',
    question: 'How do I get a receipt for my purchase?',
    answer:
      'Lorem Ipsum is placeholder text used in design, typesetting, and printing since the 1500s.',
  },
  {
    id: 'Four',
    question: 'How do I report an issue?',
    answer:
      'Lorem Ipsum is placeholder text used in design, typesetting, and printing since the 1500s.',
  },
];
const plans = [
  {
    name: 'ICB Finance Experts: Your RRA-Approved Tax Partner',
    price: null,
    original: null,
    discount: null,
    promo: null,
    yearly: null,
    renewal: null,
    mailboxes: null,
    emoji: '🏅',
    storage: null,
    outro: 'RRA-Approved tax advisory and compliance services',
    features: [
      'Tax Compliance: Accurate filing for CIT, VAT, PAYE, and Withholding Tax.',
      'Tax Advisory: Proactive planning and optimization strategies.',
      'Audit Support: Representation and assistance during RRA audits.',
      'Business Services: Bookkeeping, reporting, and financial planning.',
    ],
    tag: 'RRA-Approved Tax Advisors',
    intro:
      'We are officially approved tax advisors by the Rwanda Revenue Authority (RRA), providing trusted expertise for individuals and businesses. Our services ensure full compliance and strategic financial growth. Contact us for confident, compliant, and optimized tax management.',
    highlight: true,
  },
  {
    name: 'Professional Bookkeeping Services ',
    // price: 2.5,
    // original: 3.49,
    header: 'At ICB,we are certified Bookkeeper.',
    discount: '28%',
    // promo: "MAILDEAL",
    yearly: '$29.98/year',
    renewal: '$41.88/year',
    mailboxes: 3,
    storage: '30GB',
    emoji: '🎉',
    outro: 'Where Every Number Tells Your Success Story!',
    features: [
      'Daily Transaction Recording – Organized, up-to-date books',
      'Financial Reporting – Clear insights into your business performance',
      'Tax-Ready Records – Seamless compliance with accounting standards',
    ],
    tag: 'Your Business, Our Precision!',
    intro:
      'Accurate bookkeeping is the backbone of every successful business. Let us handle your financial records with expert care, cutting-edge tools, and absolute reliability, so you can focus on growing your business with confidence.',
    highlight: true,
    bg: true,
  },
  {
    name: 'Expert Accounting Software Installation ',
    price: 0.99,
    original: 1.24,
    discount: '20%',
    promo: 'MAILDEAL',
    yearly: '$11.88/year',
    renewal: '$14.88/year',
    mailboxes: 1,
    emoji: '🚀',
    outro: 'Smooth Software. Smarter Accounting.',
    pre: 'We are Certified QuickBooks Proadvisors',
    storage: '5GB',
    features: [
      'Flawless Installation – No errors, no delays',
      'Data Migration – Safely transfer your existing records',
      'Custom Setup – Tailored to your business needs',
      'Training & Support – Get started with confidence',
    ],
    tag: 'Set Up for Financial Success!',
    intro:
      'Tired of complicated software setups? Let us handle the installation and configuration of your QuickBooks, Sage, Xero, or other accounting software so you can focus on managing your finances—not tech issues. Our seamless service ensures your system runs smoothly from day one.',
    highlight: true,
  },
];

const Card = ({ title, description, icon, highlight, subtitle, link }) => (
  <div className={`card service-card ${highlight ? 'highlight' : ''}`}>
    <div className="service-card-top">
      <div className="card-icon service-card-icon">
        {icon.includes('.') ? (
          <img
            src={icon}
            alt={title}
            onError={e => {
              e.target.onerror = null;
              e.target.replaceWith(document.createTextNode('📄'));
            }}
            className="service-card-image"
          />
        ) : (
          <span className="service-card-emoji">{icon}</span>
        )}
      </div>
      {subtitle && <p className="card-subtitle">{subtitle}</p>}
    </div>
    <div className="service-card-content">
      <h3 className="card-title">{title}</h3>
      <p className="card-description">{description}</p>
    </div>
    {link ? (
      <a
        href={link}
        target="_blank"
        rel="noopener noreferrer"
        className="service-card-link"
      >
        Learn more <span className="service-card-arrow" aria-hidden="true">→</span>
      </a>
    ) : (
      <Link to="/Contact" className="service-card-link">
        Learn more <span className="service-card-arrow" aria-hidden="true">→</span>
      </Link>
    )}
  </div>
);
// services details card
const cardStyle = {
  flex: '1 1 300px',
  maxWidth: '20rem',
  minWidth: '280px',
  display: 'flex',
  flexDirection: 'column',
  borderRadius: '1rem',
  boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
  padding: '1.5rem',
  backgroundColor: '#fff',
  border: '1px solid #e5e7eb',
};

const PricingCard = ({ plan }) => (
  <div
    style={{
      ...cardStyle,
      outline: plan.highlight ? '2px solid #facc15' : 'none',
    }}
  >
    {plan.bg && (
      <img
        src={badge}
        alt="Badge"
        style={{ width: '64px', height: '64px', alignSelf: 'center', marginBottom: '1rem' }}
      />
    )}
    <div
      style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: '0.5rem',
      }}
    >
      <h2 style={{ fontSize: '1.25rem', fontWeight: 'bold' }}>{plan.name}</h2>
      {/* <span style={{ backgroundColor: "#ef4444", color: "white", fontSize: "0.875rem", padding: "0.25rem 0.5rem", borderRadius: "0.25rem" }}>
        {plan.discount} off
      </span> */}
    </div>
    {plan.tag && (
      <span
        style={{
          backgroundColor: '#facc15',
          fontSize: '0.75rem',
          fontWeight: '600',
          padding: '0.25rem 0.5rem',
          borderRadius: '0.25rem',
          alignSelf: 'flex-start',
          marginBottom: '0.5rem',
        }}
      >
        {plan.tag}
      </span>
    )}
    {/* <p style={{ color: "#9ca3af", textDecoration: "line-through", fontSize: "0.875rem" }}>${plan.original}/mo</p>
    <p style={{ fontSize: "2rem", fontWeight: "bold", marginBottom: "0.5rem" }}>${plan.price}/mo</p> */}
    {/* <p style={{ color: "#ef4444", fontSize: "0.875rem", marginBottom: "0.5rem" }}>
      Save {plan.discount} with a promo code
    </p> */}
    {/* <div style={{ display: "flex", alignItems: "center", marginBottom: "1rem" }}>
      <input
        type="text"
        readOnly
        value={plan.promo}
        style={{ border: "1px dashed #9ca3af", padding: "0.25rem 0.5rem", flexGrow: 1, textAlign: "center", borderTopLeftRadius: "0.375rem", borderBottomLeftRadius: "0.375rem" }}
      />
      <button style={{ backgroundColor: "#e5e7eb", padding: "0.25rem 0.75rem", borderTopRightRadius: "0.375rem", borderBottomRightRadius: "0.375rem" }}>📋</button>
    </div> */}
    {plan.header && (
      <span
        style={{
          backgroundColor: '#53a318',
          color: 'white',
          padding: '0.2rem',
          borderRadius: '0.2rem',
          fontSize: '0.65rem',
          fontWeight: '400',
          marginBottom: '0.3rem',
        }}
      >
        {plan.header}
      </span>
    )}
    <p style={{ fontSize: '0.85rem', color: '#6b7280', marginBottom: '1rem' }}>{plan.intro}</p>
    <ul style={{ fontSize: '0.875rem', listStyle: 'none', paddingLeft: 0 }}>
      {plan.features.map((feature, index) => (
        <li
          key={index}
          style={{ display: 'flex', alignItems: 'flex-start', marginBottom: '0.25rem' }}
        >
          <span style={{ color: '#22c55e', marginRight: '0.5rem' }}>✔</span>
          {feature}
        </li>
      ))}
    </ul>
    {plan.pre && (
      <p>
        <b>{plan.pre}</b>
      </p>
    )}
    <br />
    <br />
    <p>
      {plan.emoji} <b>{plan.outro}</b>
    </p>
  </div>
);

const Services = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggle = index => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <>
      <TopBar />
      <main className="page-services">
        <div className="container-fluid">
          <div className="container">
            <Navbar />
          </div>

          <section className="services-hero-section">
            <div className="container services-hero-inner">
              <span className="services-hero-kicker">Our Expertise</span>
              <h1 className="services-hero-title">
                Comprehensive <span className="services-hero-title-accent">Financial Solutions</span>
              </h1>
              <p className="services-hero-description">
                Tailored strategies designed to empower your business growth, strengthen
                compliance, and give you the financial clarity needed to make confident decisions.
              </p>
            </div>
          </section>

          <section className="services-cards-section">
            <div className="container">
              <div className="services-grid-shell">
                <div className="grid">
                  {service.map((feature, idx) => (
                    <Card key={idx} {...feature} />
                  ))}
                </div>
              </div>
            </div>
          </section>

          <section className="services-plans-section">
            {/* <div style={{ textAlign: "center", marginBottom: "2rem" }}>
            <h1 style={{ fontSize: "1.875rem", fontWeight: "bold" }}>Choose Your Plan</h1>
          </div> */}
            <div className="services-plans-grid">
              {plans.map((plan, index) => (
                <PricingCard key={index} plan={plan} />
              ))}
            </div>
          </section>
          <Certifications />
          {/*  <div className="container">
        FAQ Section 
        <section className="foi-page-section1">
          <div className="row container">
            <div className="col-md-6 mb-5 mb-md-0">
              <img src="assets/images/img_3.png" alt="faq" className="img-fluid" width="424px" />
            </div>
            <div className="col-md-6">
              <h2 className="feature-faq-title">Frequently Asked Questions</h2>

             {faqs.map((faq, index) => (
                <div className="card feature-faq-card" key={index}>
                <div
                    className="card-header bg-white d-flex align-items-center"
                    onClick={() => toggle(index)}
                    style={{ cursor: 'pointer' }}
                >
                    <h5 className="mb-0">{faq.question}</h5>
                    <i className={`far ${activeIndex === index ? 'fa-minus-square' : 'fa-plus-square'} ml-auto`}></i>
                </div>
                {activeIndex === index && (
                    <div className="card-body">
                    <p className="mb-0 text-gray">{faq.answer}</p>
                    </div>
                )}
                </div>
            ))}

            </div>
          </div>
        </section>
        </div>
        */}
          <section className="success-section">
            <div className="container">
              <div className="row center-text">
                <div className="col-text">
                  <h3 className="subtitle">Our Success</h3>
                  <h2 className="title">We have a proven track record of success.</h2>
                </div>
              </div>
            </div>

            <div className="container">
              <div className="row card-row">
                <div className="card-box">
                  <h3 className="number">60+</h3>
                  <p className="label">Trainees</p>
                </div>
                <div className="card-box">
                  <h3 className="number">18k+</h3>
                  <p className="label">Issues Solved</p>
                </div>
                <div className="card-box">
                  <h3 className="number">10k+</h3>
                  <p className="label">Happy Customers</p>
                </div>
              </div>
            </div>
          </section>
        </div>
      </main>
      <Footer />
    </>
  );
};

export default Services;
